import { createSlice } from "@reduxjs/toolkit";

/**
 * Fungsi hanya increment saja untuk trigger use effect agar reload data
 * Listener FCM hanya ada 1 di index dashboard, agar tidak ribet passing data, pakai redux
 */

export const chatRead = createSlice({
  name: "chat_read",
  initialState: {
    value: 0,
  },
  reducers: {
    updateChatRead: (state) => {
      state.value += 1;
    },
  },
});

export const { updateChatRead } = chatRead.actions;

export default chatRead.reducer;
